import * as types from "./documentVerificationActionTypes.js";

const stateObject = {
  isLoading: false,
  isSuccess: false,
  error: null,
  isError: false
};

const initialState = {
  documentListState: { ...stateObject, payload: [] },
  addDocumentState: { ...stateObject, payload: {} }
};

export default function documentVerificationReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_DOCU_LIST_LOADING:
      return {
        ...state,
        documentListState: {
          ...state.documentListState,
          isLoading: true
        }
      };
    case types.GET_DOCU_LIST_SUCCESS:
      return {
        ...state,
        documentListState: {
          ...state.documentListState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_DOCU_LIST_FAILURE:
      return {
        ...state,
        documentListState: {
          ...state.documentListState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.ADD_DOCUMENT_LOADING:
      return {
        ...state,
        addDocumentState: {
          ...state.addDocumentState,
          isLoading: true
        }
      };
    case types.ADD_DOCUMENT_SUCCESS:
      return {
        ...state,
        addDocumentState: {
          ...state.addDocumentState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.ADD_DOCUMENT_FAILURE:
      return {
        ...state,
        addDocumentState: {
          ...state.addDocumentState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    default:
      return state;
  }
}
